/**
 * THE CLASS POSTHOG'S SESSION RECORDER LEAVES OUT (its default `blockClass`): a blocked element is recorded as
 * an empty box of its size, and none of its attributes or changes are serialized.
 *
 * Every frame that takes a whole artifact as `srcdoc` wears it. The recorder can't see into a sandboxed frame
 * anyway, but it DID copy the `srcdoc` attribute: the artifact's HTML with its pictures inlined as bytes, 2MB
 * on a real deck. Each artifact switch replaced it, and the recorder serialized and gzipped every copy on the
 * main thread: 100-130ms per step, then an 820ms freeze on its flush. Stepping the pager quickly locked the
 * whole app (Beka, 2026-09-27: "when I quickly change the artifacts the entire app lags").
 *
 * A class rather than a `blockSelector` in `posthog.init`: the project's remote config may set the selector.
 */
export const NO_RECORDING = 'ph-no-capture';
